import styled from 'styled-components';
import { Column } from '../../layout/Column';

export const LabelCell = styled.div<{
  last?: boolean;
  center?: boolean;
  bgColor?: string;
}>`
  flex: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props: { center?: boolean }): string =>
    props.center ? 'center' : 'flex-start'};
  padding: 5px 10px;
  border-bottom: 1px solid var(--color-separator);
  border-right: ${(props: { last?: boolean }): string =>
    props.last ? 'none' : '1px solid var(--color-separator)'};
  & > div {
    flex: 1;
    &:last-child {
      text-align: right;
    }
  }
  background-color: ${(props: { bgColor?: string }): string =>
    props.bgColor ? props.bgColor : 'transparent'};
`;

export const DataCell = styled.div<{ lastInRow?: boolean }>`
  width: 100%;
  flex: 1;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: ${(props: { lastInRow?: boolean }): string =>
    props?.lastInRow ? 'none' : '1px solid var(--color-separator)'};
  border-bottom: 1px solid var(--color-separator);
  min-width: 0;
  overflow: hidden;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DataCellColumn = styled(DataCell as any)`
  flex-direction: column;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DataColumn = styled(Column as any)`
  height: 100%;
`;
